import { ApiParameter } from "@insite/client-framework/Services/ApiService";

// #region DynamicFormTypes

export type DynamicFormFieldTypes =
    | "DynamicFormCheckbox"
    | "DynamicFormCheckboxGroup"
    | "DynamicFormDataField"
    | "DynamicFormFileUpload"
    | "DynamicFormIntegerField"
    | "DynamicFormRadioGroup"
    | "DynamicFormSelect"
    | "DynamicFormTextArea"
    | "DynamicFormTextField";

// #region DynamicFormButton types and related consts

export type DynamicFormButtonVariants = "primary" | "secondary" | "tertiary";

export const DynamicFormButtonVariantsPrimary: DynamicFormButtonVariants = "primary";
export const DynamicFormButtonVariantsSecondary: DynamicFormButtonVariants = "secondary";
export const DynamicFormButtonVariantsTertiary: DynamicFormButtonVariants = "tertiary";

export type DynamicFormButtonShapes = "rectangle" | "pill" | "rounded";

export const DynamicFormButtonShapesRectangle: DynamicFormButtonShapes = "rectangle";
export const DynamicFormButtonShapesPill: DynamicFormButtonShapes = "pill";
export const DynamicFormButtonShapesRounded: DynamicFormButtonShapes = "rounded";

export type DynamicFormButtonTypes = "outline" | "solid";

export const DynamicFormButtonTypesOutline: DynamicFormButtonTypes = "outline";
export const DynamicFormButtonTypesSolid: DynamicFormButtonTypes = "solid";

// #endregion DynamicFormButton types and related consts

// #region DynamicFormCheckbox types and related consts

export type DynamicFormCheckboxLabelPositions = "left" | "right" | "none";

export const DynamicFormCheckboxLabelPositionsLeft: DynamicFormCheckboxLabelPositions = "left";
export const DynamicFormCheckboxLabelPositionsRight: DynamicFormCheckboxLabelPositions = "right";
export const DynamicFormCheckboxLabelPositionsNone: DynamicFormCheckboxLabelPositions = "none";

// #endregion DynamicFormCheckbox types and related consts

// #region DynamicFormCheckboxGroup types and related consts

export type DynamicFormCheckboxGroupLabelPositions = "left" | "right";

export const DynamicFormCheckboxGroupLabelPositionsLeft: DynamicFormCheckboxGroupLabelPositions = "left";
export const DynamicFormCheckboxGroupLabelPositionsRight: DynamicFormCheckboxGroupLabelPositions = "right";

// #endregion DynamicFormCheckboxGroup types and related consts

// #region DynamicFormFileUpload types and related consts

export type DynamicFormFileUploadLabelPositions = "left" | "top" | "none";

export const DynamicFormFileUploadLabelPositionsLeft: DynamicFormFileUploadLabelPositions = "left";
export const DynamicFormFileUploadLabelPositionsTop: DynamicFormFileUploadLabelPositions = "top";
export const DynamicFormFileUploadLabelPositionsNone: DynamicFormFileUploadLabelPositions = "none";

// #endregion DynamicFormFileUpload types and related consts

// #region DynamicFormIntegerField types and related consts

export type DynamicFormIntegerFieldLabelPositions = "left" | "top" | "none";

export const DynamicFormIntegerFieldLabelPositionsLeft: DynamicFormIntegerFieldLabelPositions = "left";
export const DynamicFormIntegerFieldLabelPositionsTop: DynamicFormIntegerFieldLabelPositions = "top";
export const DynamicFormIntegerFieldLabelPositionsNone: DynamicFormIntegerFieldLabelPositions = "none";

// #endregion DynamicFormIntegerField types and related consts

// #region DynamicFormTextArea types and related consts

export type DynamicFormTextAreaLabelPositions = "left" | "top" | "none";

export const DynamicFormTextAreaLabelPositionsLeft: DynamicFormTextAreaLabelPositions = "left";
export const DynamicFormTextAreaLabelPositionsTop: DynamicFormTextAreaLabelPositions = "top";
export const DynamicFormTextAreaLabelPositionsNone: DynamicFormTextAreaLabelPositions = "none";

// #endregion DynamicFormTextArea types and related consts

// #region DynamicFormTextField types and related consts

export type DynamicFormTextFieldLabelPositions = "left" | "top" | "none";

export const DynamicFormTextFieldLabelPositionsLeft: DynamicFormTextFieldLabelPositions = "left";
export const DynamicFormTextFieldLabelPositionsTop: DynamicFormTextFieldLabelPositions = "top";
export const DynamicFormTextFieldLabelPositionsNone: DynamicFormTextFieldLabelPositions = "none";

// #endregion DynamicFormTextField types and related consts

// #region DynamicFormThirdPartyApiTypes types and related consts

export type DynamicFormThirdPartyApiTypes = "custom-api";

export const DynamicFormThirdPartyApiTypesCustom: DynamicFormThirdPartyApiTypes = "custom-api";

// #endregion DynamicFormThirdPartyApiTypes types and related consts

// #endregion DynamicFormTypes

export const DynamicFormEmailRegExp = new RegExp(
    "^[\\W]*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4}[\\W]*,{1}[\\W]*)*([\\w+\\-.%]+@[\\w\\-.]+\\.[A-Za-z]{2,4})[\\W]*$",
);

export interface DynamicFormModel {
    name: string;
    isSubmitting: boolean;
    displayValidationErrors: boolean;
    fields: DynamicFormFieldModel[];
}

export interface DynamicFormFieldModel {
    key: string;
    group: string;
    type: DynamicFormFieldTypes;
    label: string;
    isRequired: boolean;
    value?: any;
    sendOnlyIfChecked?: boolean;
    changeTrueFalseToYesNo?: boolean;
    hasError: boolean;
    error?: string;
}

export interface SubmitDynamicFormApiRequestModel extends ApiParameter {
    formName: string;
    emailRecipients: string;
    sendToThirdPartyApi: boolean;
    sendToApiType: string;
    customApiEndpoint: string;
    endpointRequiresAuth: boolean;
    endpointUserId: string;
    endpointPassword: string;
    fields: DynamicFormFieldModel[];
}

export interface SubmitDynamicFormApiResponseModel {
    success: boolean;
    submitToApiResponse: string;
}

export class DynamicFormsFileUploadModel {
    constructor(key: string, fileName?: string, file?: Record<string, any>, bytes?: string) {
        this.key = key;
        this.fileName = fileName ?? undefined;
        this.file = file ?? undefined;
        this.bytes = bytes ?? "";
    }

    getKey() {
        return this.key;
    }
    getFileName() {
        return this.fileName;
    }
    getFile() {
        return this.file;
    }
    getBytes() {
        return this.bytes;
    }

    key: string;
    fileName?: string;
    file?: Record<string, any>;
    bytes: string;
}
